module.exports = __webpack_public_path__ + "img/case-logo-02.9dfb729b.png";